/* eslint-disable react/no-deprecated */
/* eslint-disable import/no-extraneous-dependencies */
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { MixpanelProvider } from 'react-mixpanel-browser';

import UnderMaintenance from 'modules/_shared/pages/_UnderMaintenance';
import { ThemeProvider } from 'modules/_shared/contexts/ThemeContext';
import { AxiosAuthProvider } from 'contexts/AxiosAuthProvider';
import { UnifiedAuthProvider } from 'UnifiedAuthProvider';

import { store, persistor } from 'redux/store';

import { initSentry } from 'setupSentry';
import { initMixpanel } from 'setupMixpanel';
import { initLogRocket } from 'setupLogRocket';
import { initPageUpdate } from 'setupPage';

import App from 'App';

import './i18n/config';

initSentry();
initMixpanel();
initLogRocket();
initPageUpdate();

const isUnderMaintenance = false;

const appUnderMaintenance = (
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider>
        <UnderMaintenance />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);

const appWithUnifiedAuth = (
  <BrowserRouter>
    <UnifiedAuthProvider>
      <Provider store={store}>
        <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
          <MixpanelProvider>
            <ThemeProvider>
              <AxiosAuthProvider>
                <App />
              </AxiosAuthProvider>
            </ThemeProvider>
          </MixpanelProvider>
        </PersistGate>
      </Provider>
    </UnifiedAuthProvider>
  </BrowserRouter>
);

let appToRender;
if (isUnderMaintenance) {
  appToRender = appUnderMaintenance;
} else {
  appToRender = appWithUnifiedAuth;
}

ReactDOM.render(appToRender, document.getElementById('root'));
